import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Nav from "./components/Nav";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import Laboratory from "./pages/Laboratory";
import Sprint from "./pages/Sprint";
import SprintHistory from "./pages/SprintHistory";
import Settings from "./pages/Settings";
import Seal from "./pages/Seal";
import Leaderboard from "./pages/Leaderboard";
import Terms from "./pages/legal/Terms";
import Privacy from "./pages/legal/Privacy";
import Footer from "./components/Footer";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ padding: "20vh 0", textAlign: "center" }}>
        <div className="overline">Consulting the Codex...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id FIRST (synchronously during render)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/laboratory" element={<Protected><Laboratory /></Protected>} />
        <Route path="/sprint/:projectId" element={<Protected><Sprint /></Protected>} />
        <Route path="/sprints" element={<Protected><SprintHistory /></Protected>} />
        <Route path="/settings" element={<Protected><Settings /></Protected>} />
        <Route path="/seal/:projectId" element={<Seal />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
